<template>
<div>
    <div v-for="asset in assets" v-bind:key="asset.id">
        <div v-if="asset.asset_type_name == 'photo'" class="mb-3">
          <a :href="asset.cover_image_url_large">
            <img class="float-left mr-5" :src="asset.cover_image_url_medium" />
          </a>
          <div class="clearfix"></div>
          <p v-if="asset.caption" class="mb-0">{{ asset.caption }}</p>
        </div>

        <iframe v-if="asset.asset_type_name == 'youtube'" :src="asset.code" frameborder="0" type="text/html" width="640" height="360" class="mb-3"></iframe>

        <div v-if="asset.asset_type_name == 'flickr'" class="mb-3">
          <p class="mb-2 mt-3"><strong>Flickr</strong></p>
          <a data-flickr-embed="true" :href="asset.code" :title="asset.caption">
            <img :src="asset.cover_image_url_medium" width="640" height="427" :alt="asset.caption">
          </a>
        </div>
    </div>
    <div class="clearfix"></div>
</div>
</template>

<script>
export default {
  props: ['assets'],

  data () {
    return {

    }
  }

}

</script>
